import Api from '@/services/Api'

export default {
  menu () {
    return Api().get('/rules/menu')
  },
  article (article) {
    return Api().get(`/rules/article/${article}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/RuleService.js